module.exports = __webpack_public_path__ + "images/emoji/clock3.b6861365c699f3c2a42e.png";